// extracted by mini-css-extract-plugin
export default {"footer":"AcceptInvitationModal_footer__H1Pq8"};